<template>
    <main-site>
        <template #main_content>
            <inertia-head>
                <title>{{ content.title}}</title>
                <meta name="description" :content="`${textShorter(content.body,150)}`"/>
                <meta property="og:title" :content="`${content.title}`"/>
                <meta property="og:description" :content="`${textShorter(content.body,150)}`"/>
                <meta name="twitter:title" :content="`${content.title}`">
                <link rel="canonical" :href="canonicalLink"/>
            </inertia-head>

            <div class="container mx-auto pt-[60px] lg:pt-1 mb-3">
                <div class="text-center place-items-center mx-2 sm:mx-auto max-w-screen-xl">
                    <div class="text-left rounded-2xl shadow-xl bg-white p-9 pt-9 border max-w-screen-xl">
                        <div class="my-3 page-header">
                            <h2> {{ content.title }} </h2>
                        </div>
                        <p class="page-body" v-html="content.body"></p>
                    </div>
                </div>
            </div>
        </template>
    </main-site>

</template>

<script>
import MainSite from "@/Pages/Components/MainSite";
import {Link, InertiaHead} from '@inertiajs/inertia-vue3'
import myMixin from "@/myMixin";

export default {
    name: "PageContent",
    components: {InertiaHead, Link, MainSite},
    mixins: [myMixin],
    props: {
        content: Object,
        canonicalLink: String,
    }
}
</script>

<style>
.page-header {
    font-family: SegoeUI;
    font-size: 5vmin;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #555454;
}

.page-body {
    margin: 16px 0 0;
    font-family: SegoeUI;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: #555454;
}
</style>
